export default __webpack_public_path__ + "static/media/gallery_06.7429f847.jpg";